import { Field, Select } from "components/shared/form";
import React, { Component } from "react";

const statuses = {
    empty: 0,
    invalid: 1,
    pending: 2,
    founded: 3,
    notFound: 4,
};

export { statuses };

export default class FormBookTemplate extends Component {
    state = {
        status: statuses.empty,
        lastValid: "",
    };

    componentDidMount() {
        if (this.props.value) {
            const { idKey, item } = this.props;
            this.getItem({ value: item[idKey || "id"] });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.value === "") {
            this.setState({ status: statuses.empty });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            const { idKey, item } = this.props;
            this.getItem({ value: this.props.value ? item[idKey || "id"] : null });
        }
    }

    setValue = ({ name, value, option }) => {
        const { onChange, idKey, tripCouplingEnabled } = this.props;
        const id = tripCouplingEnabled || !idKey ? "id" : idKey;
        onChange({ name, value: value ? { [id]: value } : null, option });
    };

    handleInvalid = () => {
        this.setState({ status: statuses.invalid });
    };

    handleValid = (data) => {
        this.setState({ status: statuses.pending, lastValid: data.value });
        return this.getItem(data);
    };

    renderField = (props) => {
        const { item } = this.props;
        return (
            <Field
                key={props.label}
                wrapper="book-field"
                onChange={this.setValue}
                value={item[props.inputProps.name]}
                {...props}
            />
        );
    };

    renderSelect = (props) => {
        const { modal, roles, profile, canEditBooks, refuelingSettings, organization } = this.props;
        const defProps = {
            key: props.label,
            wrapper: "book-field",
            onChange: this.setValue,
            value: this.props.item[props.inputProps.name],
            modal,
            roles,
            profile,
            canEditBooks,
            refuelingSettings,
            organization,
        };
        const { key, ...selectProps } = { ...defProps, ...props };
        return <Select {...selectProps} key={key} />;
    };

    render() {
        return null;
    }
}
